module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-2.a1c3fad6.png";